import axios from "../../../common/config/axios";
import * as types from "./types";

export const getBonusClaimList = (data) => (dispatch) => {
  axios
    .get("bonus_claim/list", { params: data })
    .then((res) => {
      dispatch({
        type: types.BONUS_CLAIM_LIST,
        payload: res,
      });
    })
    .catch((err) => {
      console.error(err);
    });
};